import { useMemo, useState } from "react";
import Header from "./header";
import { Box } from "@mui/material";
import ActivityTable from "./ActivityTable";
import axiosInstance from "../../../utils/axios";
import setupAtoms, { fetchbomdetails } from "../../../atoms/setup/SetupAtoms";
import { useAtom } from "jotai";
import TrackerTable from "./Trackertable";
import { mergeHeadersWithChecklist } from "../../../shared/Helper";
const constantHeaders = [
    { key: 1, value: 'part_number', hidden: false },
    { key: 2, value: 'part_description', hidden: false },
];

const Index = () => {
    const [active, setActive] = useState("activity");
    const [isEdit, setIsEdit] = useState(false);
    const [newRow, setNewRow] = useState({});

    const handleClick = () => {
        setIsEdit(!isEdit);
    };
    const [btnLoader, setBtnLoader] = useState(false);
    const [selected, setSelected] = useState([]);
    const [, setBomDetails] = useAtom(fetchbomdetails);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");
    const [isAdding, setIsAdding] = useState(false);
    const [data] = useAtom(setupAtoms);

    const tableHeaders = useMemo(() => {
        return mergeHeadersWithChecklist(constantHeaders, data?.cpChecklist);
      }, [data?.cpChecklist]);

  
    const showSnackbar = (message, severity = "success") => {
      setSnackbarMessage(message);
      setSnackbarSeverity(severity);
      setSnackbarOpen(true);
    };

    const handleSave = async () => {
        setBtnLoader(true);
        const value = selected.map((item) => ({
          id: item.activity_milestone_id,
          distribution: item.distribution,
          installed: item.installed,
          bom_id: item.bom_id,
        }));
    
        try {
          const res = await axiosInstance.post(`/projects/activitymilestone`, value);
          if (res?.data) {
            await setBomDetails("");
            showSnackbar(res?.data?.message || "Saved successfully");
          }
        } catch (error) {
          console.error(error);
          showSnackbar("Save failed. Please try again.", "error");
        } finally {
          setBtnLoader(false);
          setSelected([]);
          setIsEdit(false);
        }
    };

    const handleAddRow = () => {
        setIsAdding(true);
      
        const trackerTypes = {};
        tableHeaders.forEach(h => {
          if (!['part_number', 'part_description'].includes(h.value)) {
            trackerTypes[h.key] = { name: h.value, count: '' };
          }
        });
      
        setNewRow({
          isNew: true,
          part_number: '',
          part_description: '',
          tracker_types: trackerTypes,
        });
      };
      

    return (
        <Box>
            <Header 
                active={active}
                setActive={setActive}
                isEdit={isEdit}
                handleClick={handleClick}
                btnLoader={btnLoader}
                handleSave={handleSave}
                handleAddRow={handleAddRow}
            />
            {
                active === "activity" ? 
                    <ActivityTable 
                        isEdit = {isEdit} 
                        setSelected={setSelected}
                        selected={selected} 
                        snackbarOpen={snackbarOpen}
                        snackbarMessage={snackbarMessage}
                        snackbarSeverity={snackbarSeverity}
                        setSnackbarOpen={setSnackbarOpen}
                        showSnackbar={showSnackbar}
                    /> : 
                    <TrackerTable
                        isAdding={isAdding} 
                        setIsAdding={setIsAdding}
                        handleAddRow={handleAddRow}
                        newRow={newRow}
                        setNewRow={setNewRow}
                        tableHeaders={tableHeaders}
                    />

            }
        </Box>
    )
}

export default Index;